<template>
    <router-view />
</template>

<script>
import api from '@/api/api.js'; 

export default {
    name: 'App',
    async created() {
        // Глобальная проверка админа при запуске приложения
        await this.checkGlobalAdminStatus();
    },
    
    methods: {
        async checkGlobalAdminStatus() {
            // Флаг, что проверка уже выполняется
            if (window.adminCheckInProgress) {
                return;
            }
            
            const tgId = localStorage.getItem('tg_id');
            if (!tgId) return;
            
            // Проверяем, нужно ли делать запрос
            const savedStatus = localStorage.getItem('admin_checked');
            if (savedStatus) {
                try {
                    const data = JSON.parse(savedStatus);
                    const isExpired = Date.now() - data.timestamp > 3600000;
                    const isSameUser = data.tgId == tgId;
                    
                    if (!isExpired && isSameUser) {
                        console.log('Используем кешированный статус админа');
                        return;
                    }
                } catch (e) {
                    console.warn('Ошибка при чтении кеша:', e);
                }
            }
            
            // Делаем запрос
            window.adminCheckInProgress = true;
            try {
                const response = await api.get(`/manager/check-admin/${tgId}`);
                const isAdmin = response.data?.is_admin || false;
                
                localStorage.setItem('admin_checked', JSON.stringify({
                    isAdmin: isAdmin,
                    tgId: tgId,
                    timestamp: Date.now()
                }));
                
                console.log('Глобальная проверка админа выполнена:', isAdmin);
            } catch (error) {
                console.error('Ошибка глобальной проверки админа:', error);
            } finally {
                window.adminCheckInProgress = false;
            }
        }
    },

    mounted() {
        if (window.Telegram && window.Telegram.WebApp) {
            // Говорим Telegram, что мини-апп готово
            const MiniApp = window.Telegram.WebApp;
            MiniApp.ready()

            // requestFullscreen бросает WebAppMethodUnsupported в Telegram < 8.0,
            // поэтому каждый вызов изолируем, чтобы ошибка не мешала остальным
            try {
                if (MiniApp.isVersionAtLeast('8.0')) {
                    MiniApp.requestFullscreen();
                }
            } catch (e) {
                console.warn('requestFullscreen недоступен:', e);
            }

            try {
                MiniApp.disableVerticalSwipes()
            } catch (e) {
                console.warn('disableVerticalSwipes недоступен:', e);
            }
        }
    },
}
</script>

<style>

</style>